export default "__VITE_ASSET__85207f10__"